import { Divider, Form, FormInstance, Select, message } from "antd"
import { useEffect, useState } from "react";
import './styles.css';
import { municipioService } from "../../services/Municipios-Service/municipios-service";

interface inputMunicipioProps {
    municipioID?: number
    ehEdicao?: boolean
}

const InputSelectMunicipio = (props: inputMunicipioProps) =>{

    const [municipios, setMunicipios] = useState<any>();
    const [perfilMunicipal, setPerfilMunicipal] = useState(false)

    useEffect(()=>{
        handleOptions()
    },[])

    const handleOptions = () =>{
        var grupoLogado = parseInt(sessionStorage.getItem('grupoID') || "")
        if(grupoLogado == 1509 || grupoLogado == 1510 || grupoLogado == 1511){
            setPerfilMunicipal(true)
        }        
        municipioService.getMunicipio().then((resp)=>{
            setMunicipios(resp.data)
        })
    }

    return (
        <>
        <Form.Item name='municipioID' label='Município de Agendamento' initialValue={7385} rules={[{required:!perfilMunicipal && !props.ehEdicao, message:"Município é obrigatório"}]}>            
            {!perfilMunicipal?
            <Select defaultValue={7385} filterOption={(input: any, option: any) => {
                return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
            }} showSearch disabled={perfilMunicipal} placeholder="Selecione o município do agendamento">
             {municipios?.map((value:any, index:number)=>
                <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
            )}
            </Select>
            :
                <>
                    <span className="municipio"> {municipios?.nome}</span>
                    
                </>
            }
        </Form.Item>
        </>
    )
}

export default InputSelectMunicipio